import React, { useState } from 'react';
import { LoaderContext } from './GearLoaderContext';
import { GearLoaderKey } from '../../Model/enums/GearLoaderKey';
import GearLoader from '../../components/common/GearLoader';

interface LoaderProviderProps {
  children?: React.ReactNode;
}

export const LoaderProvider: React.FC<LoaderProviderProps> = ({ children }) => {
  const [loadersMap, setLoadersMap] = useState<Map<GearLoaderKey, number>>(new Map());

  const showLoader = (isVisible: boolean, loaderKey: GearLoaderKey): void => {
    setLoadersMap(prev => {
      const newMap = new Map(prev);
      const currentCount = prev.get(loaderKey) ?? 0;

      if (isVisible) {
        newMap.set(loaderKey, currentCount + 1);
      } else {
        const newCount = currentCount - 1;
        if (newCount <= 0) {
          newMap.delete(loaderKey);
        } else {
          newMap.set(loaderKey, newCount);
        }
      }

      return newMap;
    });
  };

  const clearAllLoaders = (): void => {
    setLoadersMap(new Map());
  };

  const isLoading = loadersMap.size > 0;

  return (
    <LoaderContext.Provider value={{ showLoader, clearAllLoaders }}>
      {children}
      {isLoading && <GearLoader />}
    </LoaderContext.Provider>
  );
};
